var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6404 43.0801C21.5851 43.4699 21.5564 43.8682 21.5564 44.2731C21.5564 48.9425 25.3647 52.7277 30.0625 52.7277C34.7603 52.7277 38.5686 48.9425 38.5686 44.2731C38.5686 43.8682 38.54 43.4699 38.4846 43.0801H59.125V61.8868C59.125 63.0541 58.1729 64.0004 56.9985 64.0004H3.12652C1.95208 64.0004 1 63.0541 1 61.8868V43.0801H21.6404Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2774 42.8643C39.2774 47.9228 35.1518 52.0234 30.0625 52.0234C24.9732 52.0234 20.8476 47.9228 20.8476 42.8643C20.8476 42.7005 20.8519 42.5376 20.8604 42.3758H1L7.77684 22.4599C8.06899 21.6013 8.87938 21.0234 9.79127 21.0234H50.3337C51.2456 21.0234 52.056 21.6013 52.3482 22.4599L59.125 42.3758H39.2646C39.2731 42.5376 39.2774 42.7005 39.2774 42.8643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9243 43.5358C37.9243 47.4446 34.4024 51.3178 30.0579 51.3178C25.7134 51.3178 22.1915 47.4446 22.1915 43.5358C22.1915 43.4092 22.1952 42.5788 22.2025 42.4538H7.375L13.1601 28.4733C13.4095 27.8098 14.1013 27.3633 14.8797 27.3633H45.2361C46.0146 27.3633 46.7064 27.8098 46.9558 28.4733L52.7409 42.4538H37.9133C37.9206 42.5788 37.9243 43.4092 37.9243 43.5358Z",
    fill: "#F0FBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88281 42.5209V61.1827C1.88281 61.8637 2.43819 62.4157 3.12329 62.4157H56.9953C57.6803 62.4157 58.2357 61.8637 58.2357 61.1827V42.5209L51.5056 22.7422C51.3352 22.2414 50.8625 21.9043 50.3305 21.9043H9.78803C9.25609 21.9043 8.78337 22.2414 8.61295 22.7422L1.88281 42.5209Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9203 42.1582C13.7107 42.1582 16.7221 42.1582 19.9544 42.1582C21.2844 42.1582 21.2844 43.0872 21.2844 43.5673C21.2844 48.2366 25.1803 52.0218 29.9862 52.0218C34.7921 52.0218 38.688 48.2366 38.688 43.5673C38.688 43.0872 38.688 42.1582 40.018 42.1582H57.7038M5.65625 42.1582H7.37609H5.65625Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8522 5.03147L39.9844 13.8053M29.4224 2V13.8053V2ZM10.9219 5.03147L18.7897 13.8053L10.9219 5.03147Z",
    stroke: "#00BADB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.f418e9cfca68384ba80a0a7359174275.svg";
export { ForwardRef as ReactComponent };